export interface IPositionDto {
    latitude: number;
    longitude: number;
}
